import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../components/primitives/SMLButton';
import { withBrandWord } from '../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Home; each part uses its own slice of it */
import styles from './ArtistHome.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface HomeKpiSetupTileProps {
  title: string;
  body: string;
  cta: string;
  /** How many of the four KPI columns the tile takes. */
  span: number;
  isPrimary?: boolean;
  onAction: () => void;
}

function spanClass(span: number): string | undefined {
  if (span >= 4) {
    return styles.span4;
  }
  if (span === 3) {
    return styles.span3;
  }
  if (span === 2) {
    return styles.span2;
  }
  return styles.span1;
}

/** A dashed tile in a KPI row that sets up the missing source (design a2 "More services", b2). */
const HomeKpiSetupTileComponent: React.FC<HomeKpiSetupTileProps> = ({
  title,
  body,
  cta,
  span,
  isPrimary = false,
  onAction,
}) => (
  <div className={clsx(styles.kpi, styles.kpiSetup, spanClass(span))}>
    <span className={styles.kpiTop}>{withBrandWord(title)}</span>
    <p>{withBrandWord(body)}</p>
    <div>
      <SMLButton
        variant={isPrimary ? 'primary' : 'default'}
        icon={isPrimary ? undefined : <FontAwesomeIcon icon={faPlus} />}
        onClick={onAction}
      >
        {cta}
      </SMLButton>
    </div>
  </div>
);

export const HomeKpiSetupTile = TypedMemo(HomeKpiSetupTileComponent);
